import { Grid, Tab, Tabs, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { PATHS } from 'config';
import { Translate } from 'shared/newComponents';
import Button from 'shared/newComponents/Button';

const styles = ({ breakpoints, palette }) => ({
  wrapper: {
    [breakpoints.down('md')]: {
      padding: 16,
    },
  },
  tabsWrapper: { borderBottom: '1px solid #b0b4b9' },
  link: { color: palette.primary.main },
  scroll: { overflow: 'auto' },
});

export const RecruiterMenu = ({
  title,
  subtitle,
  itemSelected,
  setIsModalOpen,
  currentRecruiter,
  t,
  classes,
  ...props
}) => {
  const [index, setIndex] = useState(0);

  const isSelfEdit =
    props.currentUser.id === currentRecruiter.id ||
    props.currentUser.isSuperUser;

  useEffect(() => {
    switch (itemSelected) {
      case 'show':
        setIndex(0);
        break;
      case 'personal-data':
        setIndex(1);
        break;
      case 'organizations':
        setIndex(2);
        break;
      case 'all-projects':
        setIndex(3);
        break;
      case 'settelments':
        setIndex(3);
        break;
      case 'help':
        setIndex(4);
        break;
      default:
        setIndex(0);
    }
  });

  const menuCandidateElements = [
    {
      name: t('recruiter:card'),
      route_url: 'show',
      url: PATHS.RECRUITER.SHOW.replace(':id', currentRecruiter.id),
    },
    {
      name: t('dashboard:candidateProfileTable.candidateProfileTitle'),
      route_url: 'personal-data',
      url: PATHS.RECRUITER.PERSONAL_DATA.replace(':id', currentRecruiter.id),
      disabled: !isSelfEdit,
    },

    {
      name: t('candidate:field.organization'),
      route_url: 'organizations',
      url: PATHS.RECRUITER.ORGANIZATIONS.replace(':id', currentRecruiter.id),
      disabled: !isSelfEdit,
    },
    {
      name: t('candidateDetails:menu.allProjects'),
      route_url: 'all-projects',
      url: PATHS.RECRUITER.ALL_PROJECTS.replace(':id', currentRecruiter.id),
      disabled: !isSelfEdit,
    },
    {
      name: t('help:help.tabTitle'),
      route_url: 'help',
      url: PATHS.RECRUITER.HELP.replace(':id', currentRecruiter.id),
      disabled: !isSelfEdit,
    },
  ];

  const handleTabChange = (_, index) => {};

  const subMenu = menuCandidateElements.map((element, key) => {
    let setActive = false;
    if (itemSelected === element.route_url) {
      setActive = true;
    }
    if (currentRecruiter.email === null && key !== 0) {
      return [];
    }

    if (element.disabled) {
      return [];
    }
    return (
      <Tab
        key={key}
        component={Link}
        to={element.url}
        className={setActive ? classes.active : ''}
        label={element.name}
        disabled={currentRecruiter.email === null}
        classes={{
          root: classes.button,
          label: classes.label,
        }}
      />
    );
  });

  return (
    <Grid container className={classes.wrapper}>
      <Grid
        container
        style={{ cursor: 'pointer' }}
        onClick={() => {
          props.history.goBack();
        }}
      >
        <Translate
          text="projectDetails:content.back"
          bold
          underline
          variant="body1"
          className={classes.link}
        />
      </Grid>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        style={{ padding: '8px 0 16px 0' }}
      >
        <Grid item>
          <Translate style={{ fontSize: 38 }} text={title} variant="h4" bold />
          {subtitle ? (
            <Translate
              style={{ fontSize: 20, color: '#6A6F76' }}
              text={subtitle}
              variant="h6"
              bold
            />
          ) : null}
        </Grid>
        {itemSelected === 'help' ? (
          <Grid item>
            <Button
              full
              label={t('help:help.wantHelp')}
              onClick={() => setIsModalOpen(true)}
            />
          </Grid>
        ) : null}
      </Grid>
      <Grid container>
        <Grid container className={classes.tabsWrapper}>
          <Tabs
            value={index}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleTabChange}
            classes={{
              root: classes.tabsRoot,
              indicator: classes.indicator,
              scrollButtons: classes.scrollButtons,
              flexContainer: classes.scroll,
            }}
          >
            {subMenu}
          </Tabs>
        </Grid>
      </Grid>
    </Grid>
  );
};

RecruiterMenu.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = store => {
  return {
    currentUser: store.auth.currentUser,
  };
};

export default connect(
  mapStateToProps,
  null
)(withRouter(withStyles(styles)(withTranslation()(RecruiterMenu))));
